import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { EquityFieldKey } from 'types';

const { persistAtom } = recoilPersist();

export const optionsCalculatorTickerCurrentFieldsState = atom<EquityFieldKey[]>(
  {
    key: 'optionsCalculator-tickerCurrentFieldsState',
    default: [
      EquityFieldKey.earningsDate,
      EquityFieldKey.prevClose,
      EquityFieldKey.wkHigh52,
      EquityFieldKey.wkLow52,
    ],
    effects_UNSTABLE: [persistAtom],
  },
);

export const optionsCalculatorShowKeyLevelsState = atom<boolean>({
  key: 'optionsCalculator-keyLevelsState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
